<template>
  <v-layout row wrap justify-center>
    <v-flex xs1 v-if="!loadedActive">
      <v-progress-circular
        indeterminate
        color="light-green darken-1"
      ></v-progress-circular>
    </v-flex>
    <v-flex xs12 v-if="loadedActive" id='voucher'>
      <p class="caption mb-1">{{reserva}} | {{reservation.reservation_data.origin}} | {{reservation.reservation_data.arrival | localeDateFormat}} - {{reservation.reservation_data.departure | localeDateFormat}}</p>
      <p class="title">{{reservation.reservation_data.name.lastname}} {{reservation.reservation_data.name.firstname}}</p>
      <ul class="mb-3">
        <li><span class="font-weight-bold">FECHA DE RESERVA: </span>{{reservation.reservation_data.date | localeDateFormat}}</li>
        <li><span class="font-weight-bold">CASA: </span>{{reservation.reservation_data.cabin | cabinNameLong}}</li>
        <li><span class="font-weight-bold">DOMICILIO: </span>{{reservation.reservation_data.address}}</li>
        <li><span class="font-weight-bold">LOCALIDAD: </span>{{reservation.reservation_data.city}}</li>
        <li><span class="font-weight-bold">TEL: </span>{{reservation.reservation_data.phone}}</li>
        <li><span class="font-weight-bold">EMAIL: </span>{{reservation.reservation_data.email}}</li>
        <li><span class="font-weight-bold">HUESPEDES: </span>{{reservation.reservation_data.guests}}</li>
        <li><span class="font-weight-bold">ENTRADA: </span>{{reservation.reservation_data.arrival | localeDateFormat}}</li>
        <li><span class="font-weight-bold">SALIDA: </span>{{reservation.reservation_data.departure | localeDateFormat}}</li>
        <li><span class="font-weight-bold">DÍAS: </span>{{reservation.reservation_data.days}}</li>
        <li><span class="font-weight-bold">DESAYUNO: </span>{{reservation.reservation_data.breakfast | breakfast}}</li>
        <li><span class="font-weight-bold">TARIFA DIARIA </span>${{reservation.payment_data.daily_rate}} <span v-if="voucher">(*)</span></li>
        <li><span class="font-weight-bold">MONEDA: </span>{{reservation.payment_data.badge}}</li>
        <li><span class="font-weight-bold">TARIFA TOTAL S/IVA: </span><span v-if="reservation.payment_data.total_rate_no_iva">$</span>{{reservation.payment_data.total_rate_no_iva}}</li>
        <li><span class="font-weight-bold">TARIFA TOTAL C/IVA: </span>${{reservation.payment_data.total_rate_iva}}</li>
        <li><span class="font-weight-bold">DEVOLUCIÓN IVA: </span>{{reservation.payment_data.iva_devolution}}</li>
        <li><span class="font-weight-bold">PRECOBRADO: </span>{{reservation.payment_data.pre_paid}}</li>
        <li><span class="font-weight-bold">TOTAL A PAGAR U$D: </span>{{reservation.payment_data.bill_usd}}</li>
        <li><span class="font-weight-bold">TOTAL A PAGAR AR$: </span>{{reservation.payment_data.bill_ars}}</li>
        <li><span class="font-weight-bold">TARIFA TOTAL BONIFICADA: </span>${{reservation.payment_data.bonus_rate}}</li>
        <li><span class="font-weight-bold">COEF. DESCUENTO: </span>%{{reservation.payment_data.discount_coefficient}}</li>
        <li><span class="font-weight-bold">PAGO / SEÑA: </span>${{reservation.payment_data.sign_payment}}</li>
        <li><span class="font-weight-bold">SALDO AL HACER CHECKIN: </span>${{reservation.payment_data.remaining_to_pay}}</li>
        <li><span class="font-weight-bold">A PAGAR CON TARJETA: </span>${{reservation.payment_data.credit_card_payment}}</li>
        <li><span class="font-weight-bold">A PAGAR EN EFECTIVO: </span>${{reservation.payment_data.cash_payment}}</li>
        <li><span class="font-weight-bold">HORA DE INGRESO: </span>{{reservation.reservation_data.arrival_time}}</li>
        <li><span class="font-weight-bold">OBSERVACIONES: </span>{{reservation.reservation_data.notes}}</li>
      </ul>
      <v-divider></v-divider>
      <ul>
        <li class="caption mb-1" v-for="(item, itemId) in details" :key="itemId">{{item.Valor}}</li>
        <!-- <li class="caption mb-1">Pasajero adicional AR$690/día (desde el 22/12 AR$830/dia)</li>
        <li class="caption mb-1">Se considera pax adicional a partir del año de edad</li>
        <li class="caption mb-1">Desayuno adicional AR$280 / persona y por dia</li>
        <li class="caption mb-1">Horario CHECK-IN: 14:30hs | Horario CHECK-out: 10:30hs</li> -->
      </ul>
      <v-divider v-if="voucher"></v-divider>
      <div>
        <p class="mt-3"><span class="font-weight-bold">DIRECCIÓN: </span>Los nogales 185, Puerto Manzano <br> (8407) Villa La Angostura, Neuquén, Rep. Argentina</p>
        <p class="mt-3 mb-0"><span class="font-weight-bold">TELÉFONOS</span></p>
        <p class="mb-0">+54 (294) 4825580 &nbsp;&nbsp;|&nbsp;&nbsp; +54(9294) 4516674</p>
        <p class="mb-0">
          <span class="font-weight-bold">
          Información y reservas: </span>+54 (911) 64014568
        </p>
        <p class="mt-3 mb-0"><span class="font-weight-bold">info@colinadelmanzano.com.ar <br>
          www.colinadelmanzano.com.ar</span>
        </p>
        <!-- <v-divider></v-divider> -->
      </div>
    </v-flex>
    <v-flex xs12>
      <v-layout v-if="role === 'admin'">
        <v-btn color="light-green darken-1" dark @click="printVoucher">IMPRIMIR VOUCHER</v-btn>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import filters from '@/mixins/filters';
import printJs from 'print-js';

export default {
  props: [
    'reserva',
  ],
  mixins: [
    filters,
  ],
  data() {
    return {
      voucher: false,
    };
  },
  computed: {
    reservation() {
      return this.$store.state.activeReservation;
    },
    loadedReservas() {
      return this.$store.state.loadedReservas;
    },
    loadedActive() {
      return this.$store.state.loadedActive;
    },
    role() {
      return window.localStorage.getItem('role');
    },
    details() {
      return this.$store.state.voucherDetails;
    }
  },
  mounted() {
    if (this.loadedReservas) {
      this.$store.commit('setActiveReservation', this.reserva);
    }
  },
  watch: {
    loadedReservas() {
      if (this.loadedReservas) {
        this.$store.commit('setActiveReservation', this.reserva);
      }
    },
  },
  methods: {
    printVoucher() {
      this.voucher = true;
      setTimeout(() => {
        printJs({
          printable: 'voucher',
          type: 'html',
          scanStyles: true,
          css: './node_modules/vuetify/dist/vuetify.min.css',
          targetStyles: ['*'],
          styles: '#voucher {width: 20cm !important}',
        });
        this.voucher = false;
      }, 500);
    },
  },
};
</script>
